import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad är ett provsmakningstillstånd?";
const SHORT_ANSWER = "Tillverkare och partihandlare kan få tillstånd att erbjuda provsmakning av sina produkter vid t.ex. mässor eller på den egna anläggningen.";

export const Route = createFileRoute("/fraga/vad-ar-provsmakningstillstand")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad är ett provsmakningstillstånd" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Reglerna finns i 8 kap. 6–7 §§ alkohollagen. Provsmakning får inte vara av karaktären 'servering till allmänheten'. För gårdsförsäljning gäller särskilda regler från 2026."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/gardsforsaljning", label: "Gårdsförsäljning och provsmakning" }}
      related={[{"to": "/fraga/kan-jag-overlata-mitt-tillstand", "label": "Kan jag överlåta mitt serveringstillstånd till en ny ägare?"}, {"to": "/fraga/hur-anmaler-jag-andringar", "label": "Hur anmäler jag ändringar i min verksamhet?"}, {"to": "/fraga/hur-soker-jag-uteservering", "label": "Hur söker jag tillstånd för uteservering?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad är ett provsmakningstillstånd?" },
      { name: "description", content: "Tillverkare och partihandlare kan få tillstånd att erbjuda provsmakning av sina produkter vid t.ex. mässor eller på den egna anläggningen." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-ar-provsmakningstillstand" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-ar-provsmakningstillstand" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-ar-provsmakningstillstand",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad är ett provsmakningstillstånd", url: "https://alkoholprovet.se/fraga/vad-ar-provsmakningstillstand" },
      ]),
    ],
  }),
});
